<app-rad-base-modal
    #radBaseModal
    class="rad-alert-modal"
    [identifier]="modalType"
    [title]="modalText.title"
    [closable]="true"
    [showCloseButton]="showCloseButton"
    [showConfirmButton]="showConfirmButton"
    [closeButtonText]="modalText.closeButtonText"
    [confirmButtonText]="modalText.confirmButtonText"
    [modalHeight]="'fit-content'"
    [modalWidth]="'480px'"
    [contentMaxHeight]="'none'"
    [contentMarginTop]="'16px'"
    [modalMarginTop]="'30vh'">
  <div class="rad-alert-modal__content" [innerHTML]="modalText.content"></div>
</app-rad-base-modal>
